import { PublicProfile } from "@dimensional-engineering/dimensional-models";
import { DM_Sans } from "next/font/google";

import GetPlusButton from "../GetPlusButton/GetPlusButton";
import styles from "./PremiumTraitAccessDeniedBar.module.css";
import PlusIcon from "../PlusIcon/PlusIcon";

const font = DM_Sans({ weight: "500", subsets: ["latin"] });

export default function PremiumTraitAccessDeniedBar(props: {
  notOwn?: boolean;
  traitName?: string;
  publicProfile?: PublicProfile | null;
}) {
  if (props.notOwn && props.traitName) {
    return (
      <div className={styles.main}>
        <p
          className={styles.text}
        >{`This is a premium trait. ${props.traitName} requires Dimensional Plus.`}</p>
      </div>
    );
  }

  if (props.notOwn && props.publicProfile !== undefined) {
    return (
      <div className={styles.main}>
        <p
          className={styles.text}
        >{`@${props.publicProfile?.userName} requires a Dimensional Plus account.`}</p>
      </div>
    );
  }

  return (
    <div className={styles.main}>
      <p className={styles.text}>
        {"Unlocking this Trait's score requires Dimensional Plus."}
      </p>
      <div className={styles.btnDiv}>
        <GetPlusButton source="Trait" />
      </div>
    </div>
  );
}

export function PremiumTraitAccessDeniedBarTraitAssessment() {
  return (
    <div className={styles.mainTraits}>
      <div className={styles.btnDiv}>
        <PlusIcon />
      </div>
      <p style={{ marginLeft: "0" }} className={styles.text}>
        Score only available to Dimensional Plus subscribers.
      </p>
    </div>
  );
}

export function PremiumExclusiveDeniedBAr() {
  return (
    <div className={styles.exclusiveMain}>
      <p className={styles.exclusiveText}>Score exclusive to</p>
      <h3 className={`${styles.exclusiveTextDimensional} ${font.className}`}>
        Dimensional <span className={styles.exclusiveTextPlus}>Plus</span>
      </h3>
    </div>
  );
}
